import STORE from '../STORE';
import { API } from '@/utils/api';

const { actions } = STORE.modules.reporting;
const { mutations: rootMutations } = STORE;

export default {
  namespaced: true,
  actions: {
    [actions.getBookingReportData]: async ({ dispatch }, { projects, format }) => {
      try {
        let projects_ids = projects !== null ? projects.map((item) => (item.id)) : [];

        let response = await API.get(`reporting/booking_report?${projects_ids ? 'projects_ids=' + projects_ids.join(','): ''}`);

        return response.data;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('failed', e.response);
      }
    },

    [actions.getTrialReportData]: async ({ dispatch }, reportData) => {
      return API({
        url: `reporting/trial_report`,
        method: 'POST',
        data: reportData,
        contentType: 'application/json',
        responseType: 'blob'
      });
    },

  },
};
